<template>
  <!-- 普通用户 -->
  <!-- :style="scrollDirection === 1 ? 'height: 0' : ''"
    v-if="isTeacher == false" -->
  <div class="price-wrap">
    <div
      :class="[
        'fixed-wrap',
        isShow ? 'slide-down' : 'slide-up',
        onlyFastBtn ? 'free' : ''
      ]"
    >
      <div class="fixed">
        <div class="price-group">
          <div
            :class="'price-block ' + (select === 0 ? 'active' : '')"
            @click="handleSelect(0)"
          >
            <div class="title-wrap">
              <icon name="feeling" />
              <p class="title peiban">情感陪伴</p>
              <p class="price">
                <span v-if="!isLogin || discountInfo.firstOrder"
                  >新用户￥19.9</span
                >
                <span v-else>￥58/30分钟起</span>
              </p>
            </div>
          </div>
          <!-- @tap="selectQingsu({ index: 1 })" -->
          <div
            :class="'price-block ' + (select === 1 ? 'active' : '')"
            @click="handleSelect(1)"
          >
            <div class="title-wrap">
              <icon name="Professionalconfiding" />
              <p class="title zhuanye">
                专业咨询
                <icon name="pro" />
              </p>
              <p class="price jijiang">限量半价体验</p>
            </div>
          </div>
        </div>
        <div class="btn-group">
          <div
            class="qingsu-btn active"
            v-if="select === 0"
            @click="$emit('toOrder')"
          >
            <span v-if="orderBtnLabel" v-stat="orderBtnLabel">{{
              orderBtnLabel
            }}</span>
            <span v-else-if="!this.isLogin || discountInfo.firstOrder"
              >首单￥19.9<del class="qingsu-btn-del"
                >&nbsp;原价￥58&nbsp;</del
              ></span
            >
            <span v-else>一键倾诉</span>

            <div class="active-tip" v-if="activityTime.can_use_extral_duration">
              下单加赠15分钟
            </div>
          </div>
          <a
            class="qingsu-btn active"
            v-if="select === 1"
            @click="$emit('toConsult')"
            >马上预约</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    discountInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    activityTime: {
      type: Object,
      default() {
        return {}
      }
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: true
    },
    onlyFastBtn: {
      type: Boolean,
      default: false
    },
    orderBtnLabel: {
      type: String
    }
  },
  data() {
    return {
      select: 0
    }
  },
  methods: {
    handleSelect(index) {
      this.select = index
    },
    toOrder() {
      this.toFastOrder().catch(res => {
        if (res.code === -10) {
          this.$stat.send(`倾诉-首页「当前无倾听师」提示`)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.price-wrap {
  width: 100%;
  margin: 0 auto;
  .fixed-wrap {
    transition: transform 0.5s;
    bottom: 16px;
    left: 50%;
    // height: 256px;
    @include fixedPcCenter();
    .fixed {
      // background-color: #fff;
      position: absolute;
      top: 0;
      box-sizing: border-box;
      left: 16px;
      width: 718px;
      // padding: 0 0 30px;
      box-sizing: border-box;
      // border: 1px solid #eaeaea;
      // border-radius: 20px;
      // box-shadow: 0 0 30px #eaeaea;
      .price-group {
        padding: 28px 40px;
        display: flex;
        &:after {
          clear: both;
          display: block;
          content: '';
        }
        .price-block {
          position: relative;
          color: #ccc;
          .title {
            text-align: left;
          }
          &:nth-child(1) {
            width: 55%;
          }
          &:nth-child(2) {
            width: 45%;
          }
          &.active {
            .title-wrap {
              .title {
                color: #ff745b;
              }
              .icon-Professionalconfiding,
              .icon-feeling {
                color: #ff745b !important;
              }
            }
            .tips {
              border-color: #ff745b;
              color: #ff745b;
            }
            .price {
              color: #333;
            }
          }
          .title-wrap {
            .title {
              font-size: 28px;
            }
            .icon-Professionalconfiding,
            .icon-feeling {
              float: left;
              font-size: 68px;
              line-height: 1;
              color: #ccc;
              margin-right: 15px;
              margin-top: 12px;
              width: 68px;
              height: 68px;
            }
            .icon-pro {
              font-size: 48px;
              color: inherit;
              position: absolute;
              margin-top: -15px;
              margin-left: 12px;
            }
          }
          .tips {
            position: absolute;
            top: 57px;
            left: 125px;
            height: 30px;
            line-height: 30px;
            padding-left: 5px;
            padding-right: 5px;
            border: 1px solid #ccc;
            font-size: 20px;
            border-radius: 2px;
            transform: scale(0.9);
            color: #ccc;
          }
          .price {
            font-size: 30px;
            color: #ccc;
            line-height: 42px;
            padding-top: 6px;
            text-align: left;
          }
        }
      }
      .btn-group {
        padding: 0 30px;
        position: relative;
        .qingsu-btn {
          display: block;
          width: 100%;
          height: 80px;
          line-height: 80px;
          border-radius: 40px;
          background-color: #ccc;
          color: #fff;
          font-size: 34px;
          text-align: center;
          text-decoration: none;
          &.active {
            background-color: #ff745b;
            display: block;
          }
          &#unopen {
            background-color: #ccc !important;
          }
          .qingsu-btn-del {
            margin-left: 25px;
            font-size: 28px;
            color: #ffcdc4;
          }
          .active-tip {
            position: absolute;
            right: 0;
            top: 0;
            height: 40px;
            background-image: linear-gradient(-62deg, #feba22 0%, #ff9f39 100%);
            font-family: PingFangSC-Regular;
            font-size: 22px;
            color: #ffffff;
            text-align: right;
            line-height: 42px;
            transform: translate(-30%, -50%);
            padding: 0 10px;
            border-radius: 20px 20px 20px 0;
          }
        }
      }
    }
  }
  .fixed-wrap.slide-down {
    transform: translate3d(0, 150%, 0);
  }

  .fixed-wrap.free {
    height: 80px;
    // .fixed {
    // padding-top: 30px;
    // }
    .price-group {
      display: none;
    }
  }
}
</style>
